module.exports = __webpack_public_path__ + "img/australia-liver-cancer-female.65f0f17a.png";